import SolicitacaoCancelamentoContrato from './componentes/SolicitacaoCancelamentoContrato.vue';
import SolicitacaoCancelamentoContratoLista from './componentes/SolicitacaoCancelamentoContratoLista.vue';
import SolicitacaoCancelamentoContratoForm from './componentes/SolicitacaoCancelamentoContratoForm.vue';
import SolicitacaoCancelamentoContratoRelatorio from './componentes/SolicitacaoCancelamentoContratoRelatorio.vue';

export default {
  path: '/solicitacao-cancelamento-contrato',
  component: SolicitacaoCancelamentoContrato,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoCancelamentoContratoLista,
      name: 'solicitacao-cancelamento-contrato',
    },
    {
      path: ':idCript',
      component: SolicitacaoCancelamentoContratoForm,
      name: 'solicitacao-cancelamento-contrato.editar'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoCancelamentoContratoRelatorio,
      name: 'solicitacao-cancelamento-contrato.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-cancelamento-contrato/rotas.js